import { Model } from "@vuex-orm/core";
import { required, maxLength } from "vuelidate/lib/validators";

export default class Company extends Model {
  static entity = 'companies';

  // API
  static $fetch() {
    return this.api().get('Company/')
  }
  static $get(id) {
    return this.api().get(`Company/${id}/`)
  }
  static $put(id, data) {
    return this.api().put(`Company/${id}/`, data)
  }
  static $post(data) {
    return this.api().post(`Company/`, data)
  }

  static fields() {
    return {
      id: this.number(0),
      name: this.string(""),
      nameIcon: this.string("fas fa-id-badge"),
      nameLabel: this.string("Company or Client Name"),
      address: this.string(""),
      addressIcon: this.string("fas fa-address-card"),
      addressLabel: this.string("Shipping Address"),
      alt_address: this.string(""),
      alt_addressIcon: this.string("fas fa-address-card"),
      alt_addressLabel: this.string("Alternative Address"),
      phonenumber: this.string(""),
      phoneIcon: this.string("fas fa-phone"),
      phoneLabel: this.string("Phone Number"),
      contact: this.string(""),
      contactIcon: this.string("fas fa-address-book"),
      contactLabel: this.string("Additional Contact Info")
    };
  }

  toCreatePayload() {
    return {
      name: this.name,
      address: this.address,
      alt_address: this.alt_address,
      phonenumber: this.phonenumber,
      contact: this.contact
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(64) },
        address: { maxLength: maxLength(500) },
        alt_address: { maxLength: maxLength(500) },
        phonenumber: { maxLength: maxLength(500) },
        contact: { maxLength: maxLength(500) }
      }
    };
  }
}
